import script from "./ConfiguratorModeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfiguratorModeModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__